import 'photoswipe/dist/photoswipe.css'

import { theme } from '@/shared/design-system/theme'
import PhotoSwipeLightbox, { PhotoSwipeOptions, SlideData } from 'photoswipe'
import { renderToStaticMarkup } from 'react-dom/server'
import styled from 'styled-components'
import { IcArrowLeft, IcArrowRight, IcCross } from '@healingpaper/cell-icons'
import React from 'react'

const getRemoteImageSize = (url: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.onload = function () {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
      })
    }
    img.onerror = function () {
      reject()
    }
    img.src = url
  })
}

const defaultOptions: PhotoSwipeOptions = {
  zoom: true,
  escKey: true,
  arrowKeys: true,
  returnFocus: true,
  clickToCloseNonZoomable: true,
  wheelToZoom: false,
  pinchToClose: true,
  closeOnVerticalDrag: false,
  initialZoomLevel: 'fit',
  secondaryZoomLevel: 1,
  maxZoomLevel: 2,
  loop: false,
  pswpModule: () => import('photoswipe'),
  zoomSVG: '',
}

const open = async (images: string[], index = 0): Promise<PhotoSwipeLightbox> => {
  const dataSource: SlideData[] = []

  for (let i = 0; i < images.length; i++) {
    try {
      const size = await getRemoteImageSize(images[i])

      dataSource.push({
        src: images[i],
        ...size,
      })
    } catch (e) {}
  }

  const lightbox = new PhotoSwipeLightbox({
    ...defaultOptions,
    index,
    dataSource,
    closeSVG,
    arrowNextSVG,
    arrowPrevSVG,
    paddingFn: (viewportSize) => {
      return {
        top: 0,
        bottom: 0,
        left: viewportSize.x < 800 ? 0 : viewportSize.x / 2 - 400,
        right: viewportSize.x < 800 ? 0 : viewportSize.x / 2 - 400,
      }
    },
  })

  lightbox.init()

  const target = document.querySelector<HTMLDivElement>('.pswp')
  if (target) {
    const style = document.createElement('style')
    style.innerHTML = customStyle
    target.appendChild(style)
  }

  const onPopstate = () => {
    lightbox.close()
  }

  lightbox.on('close', () => {
    window.removeEventListener('popstate', onPopstate)
    lightbox.destroy()
  })

  window.addEventListener('popstate', onPopstate)

  return lightbox
}

const customStyle = `
  .pswp__button--close {
    margin-right: 0px;
    width: fit-content;
    height: fit-content;
  }
  .pswp__counter {
    line-height: 20px;
    height: 22px;
    padding: 0px 8px;
    position: fixed;
    bottom: 84px;
    background: ${theme.colors.black};
    opacity: 0.8;
    border-radius: 20px;
    margin: 0 auto;
    left: 50%;
    text-align: center;
    text-shadow: none;
    transform: translate(-50%, 0);
    ${theme.typography.title4}
  }
`

const StyledCloseIconWrapper = styled.div`
  background-color: ${theme.colors.black};
  width: 48px;
  height: 48px;
  margin: 0px;
  svg {
    margin: 8px;
  }
`
const closeSVG = renderToStaticMarkup(
  <StyledCloseIconWrapper>
    <IcCross color={theme.colors.white} width={32} height={32} />
  </StyledCloseIconWrapper>,
)

const arrowNextSVG = renderToStaticMarkup(<IcArrowRight color={theme.colors.white} width={32} height={32} />)

const arrowPrevSVG = renderToStaticMarkup(<IcArrowLeft color={theme.colors.white} width={32} height={32} />)

const imageViewer = {
  open,
}

export type ImageObject = SlideData
export default imageViewer
